import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

interface SearchButtonProps {
  onClick: () => void;
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  iconColor?: string;
  hoverIconColor?: string;
  hoverShadow?: string;
  transitionDuration?: string;
  size?: string;
  borderRadius?: string;
  title?: string;
}

export const SearchButton: React.FC<SearchButtonProps> = ({
  onClick,
  backgroundColor = '#9CD0FF',
  hoverBackgroundColor = '#9CD0FF',
  iconColor = '#00163B',
  hoverIconColor = '#00163B',
  hoverShadow = '0 0 10px rgba(156, 208, 255, 1)',
  transitionDuration = '0.3s',
  size = '16px',
  borderRadius = '6px',
  title = 'Buscar'
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      title={title}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '6px',
        minWidth: '30px',
        minHeight: '30px',
        borderRadius: borderRadius,
        backgroundColor: isHovered ? hoverBackgroundColor : backgroundColor,
        boxShadow: isHovered ? hoverShadow : 'none',
        transition: `all ${transitionDuration} ease`,
        transform: `scale(${isHovered ? 1.1 : 1})`,
        userSelect: 'none'
      }}
    >
      <FontAwesomeIcon
        icon={faSearch}
        style={{
          color: isHovered ? hoverIconColor : iconColor,
          fontSize: size,
          transition: `all ${transitionDuration} ease`
        }}
      />
    </div>
  );
};

export default SearchButton;

